export const MAX_COVER_IMAGE_SIZE_BYTES = 5 * 1024 * 1024;
export const MAX_ADMIN_ATTACHMENT_SIZE_BYTES = 50 * 1024 * 1024;

export function formatFileSizeLimit(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return '0B';
  if (bytes >= 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(0)}MB`;
  if (bytes >= 1024) return `${(bytes / 1024).toFixed(0)}KB`;
  return `${bytes}B`;
}
